import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { PhAuthService } from '@frontend/common/src/lib/ph-auth';
import { getQueryParams } from '@frontend/common/src/lib/ph-router-store';
import { LoadKioskApi } from '@frontend/shared/kiosk/data-access/src';
import { SiteApiActionTypes } from '@frontend/shared/site/data-access/src';
import { Actions, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, first, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class AppResolver implements Resolve<boolean> {
  constructor(
    private store: Store,
    private phAuthSrv: PhAuthService,
    private actions$: Actions
  ) {}

  resolve(): Observable<boolean> {
    this.phAuthSrv.isAuthenticated$
      .pipe(
        filter((authenticated) => !!authenticated),
        mergeMap(() => this.store.pipe(select(getQueryParams))),
        filter((params) => !!(params as any)?.id)
      )
      .subscribe(({ id }) => this.store.dispatch(new LoadKioskApi({ id })));
    return this.actions$.pipe(
      ofType(SiteApiActionTypes.LoadSiteSuccessApi),
      map(() => true),
      first()
    );
  }
}
